import React from "react";

const LocalStorageConnection = (prop) => {
  const currentProj = localStorage.getItem("currentProject");
  prop.model.setCurrentProject(currentProj ? JSON.parse(currentProj) : null);
};

export default LocalStorageConnection;
